import React, { useEffect } from 'react';
import HeaderItem from '../HeaderItem';
import { useConnectionStore } from '../../../context/ConnectionContext';
import { OfflineLevelEnum } from '../../../enums/offlineLevelEnum';

const ConnectionStatusComponent: React.FC = () => {
    const { offlineLevel, setOfflineLevel } = useConnectionStore();

    useEffect(() => {
        if (navigator.onLine && offlineLevel !== OfflineLevelEnum.Online) {
            setOfflineLevel(OfflineLevelEnum.Online);
        } else if (!navigator.onLine && offlineLevel !== OfflineLevelEnum.Offline) {
            setOfflineLevel(OfflineLevelEnum.Offline);
        }
    }, [navigator.onLine]);

    const iconColor: string =
        offlineLevel === OfflineLevelEnum.BadConnectionDetected ? 'orange' : offlineLevel === OfflineLevelEnum.Offline ? 'red' : 'green';

    const statusLabel: string =
        offlineLevel === OfflineLevelEnum.BadConnectionDetected
            ? 'Poor connection'
            : offlineLevel === OfflineLevelEnum.Offline
            ? 'Offline'
            : 'Online';

    return <HeaderItem title={statusLabel} iconName={'wifi'} path={''} color={iconColor} />;
};

export default ConnectionStatusComponent;
